import RoundPinchIcon from '@/components/RoundPinchIcon';
import { Box, Fade, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import useMobile from '@/hooks/useMobile';

function CustomSelectionAlert() {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => setFade(false), 1500);

    return () => clearInterval(interval);
  }, []);

  if (isMobile) {
    return (
      <Fade in={fade}>
        <Box
          sx={{
            mt: -8.1,
            height: `calc(50% - 50px)`,
            width: '100%',
            background: 'rgba(0,0,0,0.5)',
            position: 'absolute',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '28%',
              transform: 'translate(-25%,-40%)',
              // background: 'orange',
              width: 'calc(100% - 38px)',
              height: '100%',
              alignItems: 'center',
              alignContent: 'center',
            }}
          >
            <Stack
              sx={{ height: '100%' }}
              direction="row"
              justifyContent="center"
              alignItems="center"
              // spacing={2}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <Typography
                  variant="h4"
                  sx={{ color: (theme) => theme.palette.grey[0] }}
                >
                  {t('checkout.home.cart.selectZone')}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: (theme) => theme.palette.grey[0] }}
                >
                  {t('checkout.home.cart.selectZoneDesc')}
                </Typography>
                <Box sx={{ mt: 4 }}>
                  <RoundPinchIcon sx={{ color: 'white', fontSize: 56 }} />
                </Box>
              </Stack>
            </Stack>
          </Box>
        </Box>
      </Fade>
    );
  }

  return (
    <Fade in={fade}>
      <Box
        sx={{
          mt: -8.1,
          ml: -2,
          height: `calc(97% - 38px)`,
          width: '100%',
          background: 'rgba(0,0,0,0.5)',
          position: 'absolute',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '28%',
            transform: 'translate(-50%,-50%)',
            // background: 'orange',
            width: 'calc(50% - 38px)',
            height: '50%',
            alignItems: 'center',
            alignContent: 'center',
          }}
        >
          <Stack
            sx={{ height: '100%' }}
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              <Typography
                variant="h4"
                sx={{ color: (theme) => theme.palette.grey[0] }}
              >
                {t('checkout.home.cart.selectZone')}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: (theme) => theme.palette.grey[0] }}
              >
                {t('checkout.home.cart.selectZoneDesc')}
              </Typography>
              <Box sx={{ mt: 4 }}>
                <RoundPinchIcon sx={{ color: 'white', fontSize: 56 }} />
              </Box>
            </Stack>
          </Stack>
        </Box>
      </Box>
    </Fade>
  );
}

export default CustomSelectionAlert;
